export default "__VITE_ASSET__wSz9Olp$__"